import {
  ArchiveBoxArrowDownIcon,
  ArchiveBoxIcon,
  Button,
  CheckCircleIcon,
  ChevronDownIcon,
  TrashIcon,
  XCircleIcon,
} from "@";
import { useCallback } from "react";
import { linkMultiAction } from "../api/api";

const MultiActions = ({ selectedIDs, submitted }) => {
  const selectedCount = selectedIDs.length;

  //Handles the multi-action operation  (e.g., delete, deActive, active, archive, deArchive).
  const handelMultiAction = useCallback(
    async (value) => {
      await linkMultiAction(value, selectedIDs);
      submitted();
    },
    [selectedIDs, submitted],
  );

  return (
    <>
      {/* Dropdown toggle button */}
      <button
        type="button"
        disabled={selectedCount <= 0}
        id="links-actions-dropdown-btn"
        data-dropdown-toggle="links-actions-dropdown"
        className="btn-white flex items-center gap-1"
      >
        {selectedCount} {selectedCount === 1 ? "عنصر" : "عناصر"} محددة
        <ChevronDownIcon className="h-4 w-4" />
      </button>

      <div
        id="links-actions-dropdown"
        className="z-10 hidden w-56 overflow-hidden rounded-2xl border bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
      >
        <ul
          className="flex flex-col divide-y divide-gray-200 text-sm font-medium"
          role="none"
        >
          <li>
            <Button
              type="button"
              title="حذف العناصر المحددة"
              className="btn-gust rounded-none w-full items-center justify-start"
              onClick={() => handelMultiAction("delete")}
            >
              <TrashIcon className="h-5 w-5" />
            </Button>
          </li>

          <li>
            <Button
              type="button"
              title="تعطيل العناصر المحددة"
              className="btn-gust rounded-none w-full items-center justify-start"
              onClick={() => handelMultiAction("deActive")}
            >
              <XCircleIcon className="h-5 w-5" />
            </Button>
          </li>
          <li>
            <Button
              type="button"
              title="تفعيل العناصر المحددة"
              className="btn-gust rounded-none w-full items-center justify-start"
              onClick={() => handelMultiAction("active")}
            >
              <CheckCircleIcon className="h-5 w-5" />
            </Button>
          </li>

          <li>
            <Button
              type="button"
              title="ارشفة العناصر المحددة"
              className="btn-gust rounded-none w-full items-center justify-start"
              onClick={() => handelMultiAction("archive")}
            >
              <ArchiveBoxArrowDownIcon className="h-5 w-5" />
            </Button>
          </li>
          <li>
            <Button
              type="button"
              title="تنشيط العناصر المحددة"
              className="btn-gust rounded-none w-full items-center justify-start"
              onClick={() => handelMultiAction("deArchive")}
            >
              <ArchiveBoxIcon className="h-5 w-5" />
            </Button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default MultiActions;
